export default __webpack_public_path__ + "static/media/tip6.3724979c.png";